import {useTranslation} from 'react-i18next';
import {Control, UseFormWatch, UseFormSetValue} from 'react-hook-form';
import AppMUIAutocomplete from '../../../../../../../components/common/AppMUIAutoComplete';
import {FormDataType, DateType} from '../../../types';
import {SVG} from '../../../../../../../constants/assetLists';
import AppTextInput from '../../../../../../../components/common/AppTextInput';

type Props = {
  index: number;
  control: Control<FormDataType>;
  watch: UseFormWatch<FormDataType>;
  setValue: UseFormSetValue<FormDataType>;
};

function DateField({index, watch, setValue}: Props) {
  const {t} = useTranslation();

  const dateTypeOptions = [
    {value: 'single', label: t('forms.dialog.dateTime.single')},
    {value: 'range', label: t('forms.dialog.date.range')},
  ];

  const dateType = watch(`questions.${index}.dateType` as any) ?? 'single';

  return (
    <div className="flex items-center gap-2">
      <img
        src={SVG.clockIcon}
        alt={'clock'}
        className="w-[20px] h-[20px] object-contain"
      />

      <div className="flex-1">
        <AppMUIAutocomplete
          size="small"
          label={t('forms.dialog.dateTime.selectType')}
          options={dateTypeOptions}
          value={
            dateTypeOptions.find(opt => opt.value === dateType) ||
            dateTypeOptions[0]
          }
          getOptionLabel={option => option.label}
          onChange={(_, newValue) => {
            if (newValue) {
              setValue(
                `questions.${index}.dateType` as any,
                newValue.value as DateType,
                {
                  shouldDirty: true,
                },
              );
            }
          }}
          disableClearable
        />
      </div>

      {/* Date Preview */}
      <div className="flex-1">
        <AppTextInput
          type="text"
          placeholder={
            dateType === 'single'
              ? t('forms.dialog.dateTime.datePlaceholder')
              : t('forms.dialog.dateTime.from')
          }
          disabled
          py="py-[12px]"
          className="border-none"
          startIcon={
            <img
              src={SVG.calendarBlackIcon}
              alt={'calendar'}
              className="w-[18px] h-[20px] object-contain"
            />
          }
        />
      </div>

      <div className="flex-1">
        {dateType !== 'single' && (
          <AppTextInput
            type="text"
            placeholder={t('forms.dialog.dateTime.to')}
            disabled
            className="border-none"
            py="py-[12px]"
            startIcon={
              <img
                src={SVG.calendarBlackIcon}
                alt={'calendar'}
                className="w-[18px] h-[20px] object-contain"
              />
            }
          />
        )}
      </div>
    </div>
  );
}

export default DateField;
